import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/manrope';
import '@fontsource-variable/vazirmatn';
import App from './App';
import { AppProvider } from './context/AppProvider';
import './styles/index.css';

// The root provider owns locale and colour preferences for the complete experience.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);
